import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api, tokenManager } from '@/api/client'
import { setBadgeCount } from '@/platform/badge'

interface ApprovalsListResponse {
  approvals: unknown[]
  total: number
}

/**
 * The pending-approvals count for the sidebar badge — also the single source
 * for the native app-icon badge (#2573, `platform/badge.ts`), so the two
 * never drift. No-op on web.
 *
 * Refreshed by `useEventStream`'s `['agent-approvals']` invalidation on every
 * live approval-created/resolved notification; the 60s `refetchInterval` is a
 * documented safety net for a session that missed the event stream, not the
 * primary update path.
 */
export function usePendingApprovalsCount(): number {
  const { data } = useQuery({
    queryKey: ['agent-approvals', 'count'],
    queryFn: async () => {
      const res = await api.get<ApprovalsListResponse>('/agent/approvals?limit=1')
      return res?.total ?? 0
    },
    enabled: tokenManager.hasValidToken(),
    refetchInterval: 60_000,
  })

  const count = data ?? 0

  useEffect(() => {
    void setBadgeCount(count)
  }, [count])

  return count
}
